<template>
  <div>
    <NavigationHeader title="Accessibilité" />

    <section class="layout-section rte">
      <p>
        Ce site est construit en conformité aux
        <a href="https://www.w3.org/WAI/standards-guidelines/wcag/fr" target="_blank" rel="noopener noreferrer">
          Règles pour l’accessibilité des contenus Web (WCAG) 2.
        </a>
      </p>

      <p>
        Ce site est compatible avec les
        <strong>outils d'accessibilité</strong>
        intégré dans les navigateurs populaires.
      </p>

      <p>Pour plus d'information à propos des outils d'accessibilité intégré dans les navigateurs :</p>
      <p><strong>Firefox</strong></p>

      <p class="rteindent1">
        <a
          href="https://support.mozilla.org/fr/kb/fonctionnalites-accessibilite-adapter-firefox-tous-utilisateurs"
          target="_blank"
          rel="noopener noreferrer"
        >
          Fonctionnalités d’accessibilité dans Firefox
        </a>
      </p>

      <p><strong>Google Chrome</strong></p>

      <p class="rteindent1">
        <a
          href="https://www.google.com/intl/fr/accessibility/products-features/#!#chrome-browser"
          target="_blank"
          rel="noopener noreferrer"
        >
          Produits et fonctionnalités d'accessibilité de Google - Navigateur Chrome
        </a>
      </p>

      <p><strong>Safari</strong></p>

      <p class="rteindent1">
        <a href="https://www.apple.com/ca/fr/accessibility/" target="_blank" rel="noopener noreferrer">
          Apple - Accessibilité
        </a>
      </p>

      <p class="rteindent1">
        <a href="https://support.apple.com/fr-ca/accessibility" target="_blank" rel="noopener noreferrer">
          Assistance Accessibilité
        </a>
      </p>

      <p><strong>Microsoft Edge</strong></p>

      <p class="rteindent1">
        <a
          href="https://support.microsoft.com/fr-fr/microsoft-edge/fonctionnalit%C3%A9s-d-accessibilit%C3%A9-de-microsoft-edge-4c696192-338e-9465-b2cd-bd9b698ad19a"
          target="_blank"
          rel="noopener noreferrer"
        >
          Fonctionnalités d’accessibilité de Microsoft Edge
        </a>
      </p>

      <p>
        S'il vous plaît
        <RouterLink :to="{ name: 'contact' }">nous contacter</RouterLink>
        si vous trouverez les problèmes.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Accessibility'
}
</script>
